import { render, staticRenderFns } from "./multi-property-picker.vue?vue&type=template&id=5ca849c0&"
import script from "./multi-property-picker.vue?vue&type=script&lang=js&"
export * from "./multi-property-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports